define('presentation/welcome/facades/onboardingInformationFacade',[
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'common/promises/promiseFactory',
    'persistence/repositories/liveReceptionistOnboardingRepository'
], function() {

    const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');

    let _liveReceptionistOnboardingRepository = null;
    let _promiseFactory = null;

    const _getLiveReceptionistOnboarding = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.getLiveReceptionistOnboarding()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _getBillingAddress = () => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingRepository.getBillingAddress()
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveAddressLineOne = (addressLineOne) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveAddressLineOne(addressLineOne)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveAddressLineTwo = (addressLineTwo) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveAddressLineTwo(addressLineTwo)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveCity = (city) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveCity(city)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveEmailAddress = (emailAddress) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveEmailAddress(emailAddress)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveFaxNumber = (faxNumber) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveFaxNumber(faxNumber)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _savePhoneNumber = (phoneNumber) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.savePhoneNumber(phoneNumber)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _savePostalCode = (country, postalCode) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.savePostalCode(country, postalCode)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveStateOrProvince = (country, stateOrProvince) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveRegion(country, stateOrProvince)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveTeamMembers = (teamMembers) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveTeamMembers(teamMembers)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveWebsiteUrl = (websiteUrl) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveWebsiteUrl(websiteUrl)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _saveOnboardingInformation = (information) => {
        return _promiseFactory.defer((deferredObject) => {
            _liveReceptionistOnboardingState.saveOnboardingInformation(information)
                .fail(deferredObject.reject)
                .done(deferredObject.resolve);
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;

        const LiveReceptionistOnboardingRepositoryConstructor = require('persistence/repositories/liveReceptionistOnboardingRepository');
        _liveReceptionistOnboardingRepository = new LiveReceptionistOnboardingRepositoryConstructor();
    };

    return function() {
        let self = this;
        self.init = _init;

        self.getLiveReceptionistOnboarding = _getLiveReceptionistOnboarding;
        self.getBillingAddress = _getBillingAddress;
        self.saveOnboardingInformation = _saveOnboardingInformation;
        self.saveAddressLineOne = _saveAddressLineOne;
        self.saveAddressLineTwo = _saveAddressLineTwo;
        self.saveCity = _saveCity;
        self.saveEmailAddress = _saveEmailAddress;
        self.saveFaxNumber = _saveFaxNumber;
        self.savePhoneNumber = _savePhoneNumber;
        self.savePostalCode = _savePostalCode;
        self.saveStateOrProvince = _saveStateOrProvince;
        self.saveTeamMembers = _saveTeamMembers;
        self.saveWebsiteUrl = _saveWebsiteUrl;
    };
});

